import React from "react";

import {
  MediumTextNC,
  ColorRed,
  ColorBlack,
  Text1,
  Text2,
  Text3,
} from "./settings.styles";

const PasswordGreeting = ({ email }) => {
  let hours = new Date().getHours();
  const partOfDay =
    hours >= 18 ? "Evening" : hours > 12 ? "Afternoon" : "Morning";
  let len = email.length;

  return (
    <div className='k-text-center'>
      <MediumTextNC>
        <ColorRed>{`Good ${partOfDay}`}</ColorRed>
      </MediumTextNC>
      <MediumTextNC>
        <ColorRed>Changing Password for</ColorRed>
      </MediumTextNC>
      {len < 25 ? (
        <Text3>{email}</Text3>
      ) : len < 40 ? (
        <Text2>{email}</Text2>
      ) : (
        <Text1>{email}</Text1>
      )}
    </div>
  );
};

export default PasswordGreeting;
